import { render, staticRenderFns } from "./Unsubscribe.vue?vue&type=template&id=30dbf7be&scoped=true&"
import script from "./Unsubscribe.vue?vue&type=script&lang=js&"
export * from "./Unsubscribe.vue?vue&type=script&lang=js&"
import style0 from "./Unsubscribe.scss?vue&type=style&index=0&id=30dbf7be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dbf7be",
  null
  
)

export default component.exports